<script>
import baseList from "@/views/components/base/baseList.vue";
import { Button } from "view-design";
export default {
  extends: baseList,
  components: {},
  data() {
    return {
      table: {
        mname: "usertag",
        key: "id",
        url: {},
        output: false,
        order: "create_time desc",
      },
      actions: [
        {
          label: "新增",
          icon: "md-add",
          onClick: this.toAdd,
          auth: "/admin/usertag/add",
        },
      ],
      tactions: [
        // { label: '导出数据', type: 'success', onClick: this.exportData.bind(this, '商家数据', 0), auth: '/admin/spot/lists' },
        // { label: '导出全部数据', type: 'error', onClick: this.exportData.bind(this, '商家数据', 1), auth: '/admin/spot/lists' },
      ],
      menus: [
        {
          label: "标签列表",
          name: "usertag_list",
          auth: "/admin/usertag/lists",
          // badge: { mname: "statisticsstats", scene: "recycle_notverify" },
        },
      ],
      query: {},
      filters: [
        {
          label: "技术分类",
          name: "category_id",
          value: 1,
          type: "select",
          dropList: [],
        },
        { label: "标题", name: "title", value: "", type: "input" },
      ],
      tableCols: [
        {
          title: "ID",
          key: "id",
          width: 120,
          align: "center",
        },
        {
          title: "名称",
          key: "name",
          minWidth: 160,
          align: "center",
        },
        {
          title: "备注",
          key: "image",
          minWidth: 160,
          align: "center",
        },
        {
          title: "状态",
          align: "center",
          key: "status",
          minWidth: 80,
          switch: true,
          disabled: false,
        },
        {
          title: "创建时间",
          align: "center",
          key: "create_time",
          minWidth: 170,
        },
        {
          title: "操作",
          align: "center",
          width: 150,
          key: "handle",
          fixed: "right",
          handle: [
            (vm, h, currentRow, param) => {
              const row = param.row;
              let directives = [{ name: "auth", value: "/admin/usertag/edit" }];
              return (
                <Button
                  {...{ directives }}
                  size="small"
                  onClick={() => this.toEdit(currentRow)}
                  type="info"
                  style={{ margin: "4px 5px" }}
                >
                  编辑
                </Button>
              );
            },
             (vm, h, currentRow, param) => {
              const row = param.row
              if(row.is_sys!=1){
              let directives = [{ name: "auth", value: "/admin/usertag/del" }];
              return (
                <Poptip confirm={true} title={'请检查数据, 再确认提交'} {...{ on: { 'on-ok': () => this.delBtn(currentRow) } }} >
                  <Button {...{ directives }} size="small" type="error"  style={{ margin: "4px 5px" }}>
                  删除
                  </Button>
                </Poptip>
              );
              }
            }
          //  "delete",
          ],
          auth: {
            edit: "/admin/usertag/edit",
            del: "/admin/usertag/del",
          },
        },
      ],
    };
  },
  created() {
  },
  methods: {
    delBtn(currentRow){
      let d = {}
      d.kv = currentRow.id
      $utils.api.load('usertagdel', d).then((res) => {
        if(res.code == 1){
         this.search()
        }
      })
    },
    toAdd() {
      $utils.url.push({
        name: "usertag_add",
        query: {
          action: "add",
        },
      });
    },
    toEdit(row) {
      let id = row.id;
      $utils.url.push({
        name: "usertag_edit",
        query: { action: "edit", kv: id },
      });
    },
  },
};
</script>
